import { render, staticRenderFns } from "./TeamInviteDialog.vue?vue&type=template&id=0174cf6a&scoped=true"
import script from "./TeamInviteDialog.vue?vue&type=script&lang=js"
export * from "./TeamInviteDialog.vue?vue&type=script&lang=js"
import style0 from "./TeamInviteDialog.vue?vue&type=style&index=0&id=0174cf6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0174cf6a",
  null
  
)

export default component.exports